module.exports = __webpack_public_path__ + "img/user_icon.dff5bd6a.png";